var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/html.js